import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 4 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "1.9",
      cy: "1.9",
      r: "1.9",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.9",
      cy: "10.7",
      r: "1.9",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.9",
      cy: "19.5",
      r: "1.9",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }